import { render, staticRenderFns } from "./companyUserDetail.vue?vue&type=template&id=01375e6e&scoped=true&"
import script from "./companyUserDetail.vue?vue&type=script&lang=js&"
export * from "./companyUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./companyUserDetail.vue?vue&type=style&index=0&id=01375e6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01375e6e",
  null
  
)

export default component.exports